import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../../Components/Forms/renders";
import MultiSelect from "../../../../Components/Forms/multiselect";
import UploadFrom from "../../../../Components/Forms/upload";
import { fetchReserveringssystemen } from "../Reducers/actions";
const selector = formValueSelector("bedrijfi_edit"); //

const BedrijvenForm = (props) => {
  const { handleSubmit, change } = props;
  const dispatch = useDispatch();
  const [showMollie, setShowMollie] = useState(false);
  const [showPlattegrond, setShowPlattegrond] = useState(false);
  const [reserveringssystemen, setReserveringssystemen] = useState([]);
  const modulesValue = useSelector((state) => selector(state, "modules"));
  const reserveringssystemenFromStore = useSelector((state) => state.bedrijven.reserveringssystemen);
  
  const createslug = (event, value) => {
    var slug = value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w]+/g, "")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
    change("slug", slug);
  };

  const checkslug = (value) => {
    return value
      .toString()
      .replace(/ /g, "-")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w]+/g, "-")
      .replace(/ /g, "-");
  };
  useEffect(() => {
    // Haal reserveringssystemen op bij component mount
    dispatch(fetchReserveringssystemen());
  }, [dispatch]);

  useEffect(() => {
    if (modulesValue && (modulesValue.includes("ervaringen") || modulesValue.includes("sensoren"))) {
      setShowMollie(true);
    } else {
      setShowMollie(false);
    }
    if (modulesValue && modulesValue.includes("sensoren")) {
      setShowPlattegrond(true);
    } else {
      setShowPlattegrond(false);
    }
  }, [modulesValue]);
  
  useEffect(() => {
    const options = {
      "": "Geen reserveringssysteem"  // Lege waarde voor geen selectie
    };
    if (reserveringssystemenFromStore && reserveringssystemenFromStore.length > 0) {
      reserveringssystemenFromStore.forEach(system => {
        options[system._id] = system.naam;
      });
    }
    setReserveringssystemen(options);
  }, [reserveringssystemenFromStore]);
  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-12">
              <Field name="naam" onChange={createslug} type="input" validate={[required()]} component={renderField} label="Naam Bedrijf" />
              <Field name="beschrijving" type="input" component={renderTextField} label="Vul korte bedrijving van je bedrijf" />
              <Field name="group" type="input" component={renderField} label="Vul een groupnaam in als nodig" />
              <Field name="slug" normalize={checkslug} type="input" component={renderField} label="Korte naam bedrijf (slug)" />
              <Field name="email" type="email" component={renderField} label="E-mailadres van de hoofdgebruiker" />
              <Field name="website" type="input" component={renderField} label="Website" />
              <Field name="straat" type="input" component={renderField} label="Straat en huisnumer" />
              <div className="row">
                <div className="col-4">
                  <Field name="postcode" type="input" component={renderField} label="Postcode" />
                </div>
                <div className="col-8">
                  <Field name="plaats" type="input" component={renderField} label="Plaats" />
                </div>
              </div>

              <Field name="telefoon" type="input" component={renderField} label="Telefoonnummer" />
              <Field
                name="soort"
                type="input"
                validate={[required()]}
                component={renderselect}
                options={{
                  camping: "Camping",
                  hotel: "Hotel",
                  bungalowpark: "Bungalowpark",
                  vakantiepark: "Vakantiepark",
                  groepsaccommodatie: "Groepsaccommodatie",
                  jachthaven: "Jachthaven",
                  zwembad: "Zwembad",
                  sauna: "Sauna",
                  sportschool: "Sportschool",
                }}
                label="Soort bedrijf"
              />
              <Field
                name="modules"
                type="input"
                allowCreate="false"
                component={MultiSelect}
                options={["horecas", "recreatie", "logboeken", "trainingen", "faciliteiten", "sensoren", "biepp", "activiteiten", "gastenverbruik", "items", "thema", "arangementen", "ervaringen", "cms", "vacatures", "accommodaties", "kampeerplaatsen", "EBS", "arrangementen", "facility-management","preventief-onderhoud"]}
                label="Modules die je wil activeren"
              />
              <Field
                name="reserveringssysteem"
                type="input"
                component={renderselect}
                options={reserveringssystemen}
                label="Selecteer reserveringssysteem"
              />
              {showMollie && (
                <span>
                  <Field name="mollie" type="input" component={renderField} label="Mollie API Key" />
                  <Field name="homepage" type="input" component={renderField} label="Website bedrijf" />
                  <Field name="vakantieverbruikUrl" type="input" component={renderField} label="Wesbite van vakantieverbruik" />
                  
                </span>
              )}
              {showPlattegrond && <Field name="plattegrond" type="input" component={UploadFrom} label="Upload hier de plattengrond van het bedrijf" />}
              <Field name="logo" type="input" component={UploadFrom} label="Upload hier het logo van het bedrijf" />
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Updates" />
          </div>
        </div>
      </form>
    </div>
  );
};
let ReduxBedrijvenForm = reduxForm({
  form: "bedrijfi_edit",
})(BedrijvenForm);

ReduxBedrijvenForm = connect((state) => ({
  initialValues: state.bedrijven.item,
}))(ReduxBedrijvenForm);

export default ReduxBedrijvenForm;
